const CartControls = {
  init(target) {
    const summary = target.querySelector('.cartcontrols__summary')
    const summaryBtn = target.querySelector('.cartcontrols__summarybtn')
    const iconList = summaryBtn?.querySelector('.button__icon-list')
    const iconX = summaryBtn?.querySelector('.button__icon-x')

    if (summaryBtn) {
      summaryBtn.addEventListener('click', () => this.toggle(summary, target, iconList, iconX))
    }
  },

  toggle(summary, target, iconList, iconX) {
    if (summary.classList.contains('cartcontrols__summary--open')) {
      summary.classList.remove('cartcontrols__summary--open')
      target.classList.remove('cartcontrols--open')
      iconList.classList.remove('d-none')
      iconX.classList.add('d-none')
    } else {
      summary.classList.add('cartcontrols__summary--open')
      target.classList.add('cartcontrols--open')
      iconList.classList.add('d-none')
      iconX.classList.remove('d-none')
    }
  },
}

export default CartControls
